<template>
  <info-header-card :header="header" :rows="rows" />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";

export default {
  name: "TurnaroundCard",
  components: {
    InfoHeaderCard
  },
  props: {
    turnaround: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    header() {
      return this.turnaround.name;
    },
    rows() {
      return [
        {
          label: "Name",
          value: this.turnaround.name
        },
        {
          label: "Turnaround",
          value: this.formatTurnaround()
        },
        {
          label: "Surcharge",
          value: this.formatSurcharge()
        },
        {
          label: "Description",
          value: this.turnaround.description
        }
      ];
    }
  },
  methods: {
    formatSurcharge() {
      if (this.turnaround.surcharge_type === "flat") {
        return `$${this.turnaround.surcharge.toFixed(2)}`;
      } else if (this.turnaround.surcharge_type === "percent") {
        return `${parseFloat(this.turnaround.surcharge)}%`;
      }
    },
    formatTurnaround() {
      return `${this.turnaround.turnaround} Day${
        parseInt(this.turnaround.turnaround) === 1 ? "s" : ""
      }`;
    }
  }
};
</script>
